<template>
  <div class="content">
    <QA :loading.sync="loading" :qidList="qidList" :isEnd="isEnd" :selectedQidSmall="selectedQidSmall" @getAnswer="getAnswer"></QA>
  </div>
</template>

<script>
import QA from '../components/Q&A.vue';
import { answerUpload } from '@/services/exam'

const datumMap = {
  1: {
    type: 'textArray',
    label: '资料1',
    value: [
      { text: '美国作家戴维•凯尔发表《跟你说话的时候大拇指别动了好吗》一文。凯尔提到聚会中，你跟一个人说话，他拿着手机，不时点个头，适当时候会“嗯”几声。但是，他根本没真心在听你讲话，他狠盯着手中的智能手机，让人觉得很不舒服。凯尔说：“让我们给数字革命加一条‘功绩’：它让人们变得粗鲁了。”这种个体在社交场合只顾低头玩手机, 而无暇顾及(冷落)身边人或事物的行为,被称作“手机冷落行为”。' },
      { text: '<p>【摘编自：新浪新闻中心《跟你说话的时候 大拇指别动了好吗》，2011年4月；龚艳萍等《手机冷落行为的前因、后果与作用机制》，《心理科学进展》2019年第27卷第7期】</p>', type: 'noTextIndent' },
    ]
  },
  2: {
    type: 'textArray',
    label: '资料2',
    value: [
      { text: '观点1：手机媒介利于人际关系' },
      { text: '手机使得人际交往方式不再局限于面对面交流、写信等传统手段，它极大地丰富了人际之间的信息传播手段。手机的功能日益多元化，包括游戏娱乐、购物、阅读等，这些多样化的功能性内容为人们提供了多元化的人际交往纽带。' },
      { text: '观点2：手机媒介危害人际关系' },
      { text: '在手机媒介环境下，手机降低了人际交往的诚信度，使得建构在手机互联基础上的人际关系更加疏远。随着人们玩手机的时间越来越长，手机就成为了一个陷阱，阻隔了人与人之间的直接交流，导致个体不愿或者不能与他人进行正常的人际交流，形成社交障碍。' },
      { text: '【摘编自：陈玲芝《手机媒介对人际关系的影响研究》，华东师范大学2016年】', type: 'noTextIndent' }
    ]
  },
  3: {
    type: 'textArray',
    label: '资料3',
    value: [
      { text: '中小学生使用手机等移动终端的主要用途由高到低依次为：网上学习（38.25%）、玩网络游戏（25.37%）、看小说和视频（21.69%）、聊天社交（14.69%），其中娱乐类项目占比达到了61.75%。调研对象首选的娱乐类项目是网络游戏，占娱乐类项目比例最高，达到41.08%。' },
      { text: '未成年手机游戏用户中，在工作日玩手机游戏日均超过2小时的达到 13.2%，略高于2019年的12.5%，如图1所示。' },
      { img: require('@/assets/exam/46.png') },
      { text: '图 1', textAlign: 'center' },
      { type: 'noTextIndent', text: '【摘编自：东北师范大学中国农村教育发展研究院与光明日报联合调研组《孩子用手机如何“拿得起放得下”——中小学生手机使用现状与干预措施调查》，《云南教育(视界综合版》2021年第5期；共青团中央维护青少年权益部等《2020年全国未成年人互联网使用情况研究报告》，2021年7月】' }
    ]
  },
  4: {
    type: 'textArray',
    label: '资料4',
    value: [
      { text: '“常州市中小学学生手机使用情况问卷调查”显示，智能手机在中小学生中的使用已较为普及。拥有手机学生的数量占比为53.68%，且手机使用率随学段提高而提高。25.26%的学生每日使用手机时长为1-2小时，15.79%的学生每日使用手机时长超过2小时。中小学生使用手机的用途中，查看老师布置的作业占比55.79%，其次是上网课和社交娱乐，分别占比46.32%和45.26%。' },
      { type: 'noTextIndent', text: '【摘编自：常州市教育局《常州市中小学学生手机使用情况调查结果反馈》，2021年10月】' }
    ]
  },
  5: {
    type: 'textArray',
    label: '资料5',
    value: [
      { text: '《95后手机使用心理与行为白皮书》显示，95后吃喝玩乐和学习生活都更加依赖手机，手机是他们的生活助手、学习老师，也是他们随身携带的智慧大脑，如图2所示。' },
      { img: require('@/assets/exam/47.png') },
      { text: '图 2', textAlign: 'center' },
      { text: '95后平均每天用手机学习约1.5小时，比95前多出84%。进一步分析发现，95后使用手机学习最多的内容是英语，其次包括学习付费知识、了解资讯、查阅信息等。较多95后表示使用手机学习较为方便，能够帮助他们充分利用碎片化时间，让他们随时随地学习。55%的95后最渴求学习类APP，学习改变命运这一名言也深深印入95后的脑海。如今的95后更具“知性”，渴望自我丰富，从而可以提高自己的核心竞争力，通过自我迭代、蜕变在不断变化的社会中立于“不败之地”。' },
      { type: 'noTextIndent', text: '【摘编自：北京大学心理与认知科学学院《95后手机使用心理与行为白皮书》，2019年4月】' },
    ]
  }
}

export default {
  components: {
    QA
  },
  data() {
    return {
      qidList: [{
        qid: 1,
        // title: '题目1',
        small: [
          {
            id: 1,
            title: '题目1',
            desc: ['1. 关于手机媒介对人际关系的影响，同学们持有不同观点。你认为手机媒介是否有利于人际关系？请说明观点，并解释理由。'],
            durationTime: 100,
            stemContent: [
              {
                type: 'text',
                value: '某校几位学生围绕“手机使用的利弊”话题展开讨论，查阅了相关资料，请你加入他们的讨论吧。'
              }
            ],
            askList: [
              {
                id: 1,
                type: 1,
                isReview: true
              }
            ]
          },
          {
            id: 2,
            title: '题目2、3',
            desc: [
              '2.戴维·凯尔的主要观点是“数字革命让人们变得粗鲁了”，支持这一观点的理由是（单选）',
              '①拿着手机不时点头或“嗯”几声',
              '②眼睛盯着手机，没有认真听讲话',
              '③交谈中使用手机让人感觉不舒服',
              '④数字革命导致手机冷落行为发生',
            ],
            durationTime: 100,
            stemContent: [
              {
                type: 'text',
                value: '小王同学曾经亲身体验过“世界上最遥远的距离是我坐在你面前，你却在玩手机”。为此，他查阅了“资料1”。'
              },
              datumMap[1]
            ],
            askList: [
              {
                id: 1,
                type: 5,
                answer: '',
                value: [
                  {
                    type: 'text',
                    val: 'A. ①②③',
                    clickStats: 'click_option_a#点击选项A',
                  },
                  {
                    type: 'text',
                    val: 'B. ①②④',
                    clickStats: 'click_option_b#点击选项B',
                  },
                  {
                    type: 'text',
                    val: 'C. ①③④ ',
                    clickStats: 'click_option_c#点击选项C',
                  },
                  {
                    type: 'text',
                    val: 'D. ②③④',
                    clickStats: 'click_option_d#点击选项D',
                  }
                ]
              },
              {
                id: 2,
                type: 2,
                title: '3. 戴维·凯尔在阐述观点时存在的主要问题包括（多选）',
              },
              {
                id: 2,
                type: 6,
                answerList: [],
                statsTopic: 'A-3',
                value: [
                  {
                    type: 'text',
                    val: 'A. 观点与理由联系不够紧密',
                    clickStats: 'click_option_a#点击选项A#cancel_option_a#取消选项A',
                  },
                  {
                    type: 'text',
                    val: 'B. 支持观点的理由不够全面',
                    clickStats: 'click_option_b#点击选项B#cancel_option_b#取消选项B',
                  },
                  {
                    type: 'text',
                    val: 'C. 仅凭借个人感受得出观点，理由的支持力度较弱',
                    clickStats: 'click_option_c#点击选项C#cancel_option_c#取消选项C',
                  },
                  {
                    type: 'text',
                    val: 'D. 虚构支持个人观点的理由，阐述观点的过程无效',
                    clickStats: 'click_option_d#点击选项D#cancel_option_d#取消选项D',
                  },
                ]
              },
            ]
          }
        ]
      }, {
        qid: 2,
        // title: '题目2',
        small: [
          {
            id: 3,
            title: '题目4',
            topicNumber: 4,
            durationTime: 100,
            desc: ['4. 请你结合“资料2”，分析手机媒介对人际关系有哪些影响。'],
            stemContent: [
              datumMap[2]
            ],
            askList: [
              {
                id: 1,
                type: 1
              }
            ]
          },
          {
            id: 4,
            title: '题目5',
            topicNumber: 5,
            stemContent: [
              {
                type: 'text',
                value: '你的第1题的答案：',
                noTextIndent: true,
                fontWeight: true
              },
              {
                type: 'text',
                value: '',
                fontFamily: true,
              },
              datumMap[1],
              datumMap[2],
            ],
            durationTime: 100,
            desc: ['5. 阅读资料1和资料2后，对于第1题中你的观点是否有改变？如果改变，请说明理由。如果没改变，请补充新理由。'],
            askList: [
              {
                id: 1,
                type: 1
              }
            ],
          }
        ]
      }, {
        qid: 3,
        // title: '题目3',
        small: [
          {
            id: 5,
            title: '题目6',
            topicNumber: 6,
            stemContent: [
              {
                type: 'text',
                value: '小张同学希望了解青少年使用手机的主要用途和时长，查阅了“资料3”、“资料4”和“资料5”。'
              },
              datumMap[3],
              datumMap[4],
              datumMap[5],
            ],
            durationTime: 100,
            desc: ['6. 在学习相同内容、相同时长的情况下，与使用书本学习相比，使用手机学习有何优势与问题？请解释说明。（结合资料3-5或生活实际均可）'],
            askList: [
              {
                id: 3,
                type: 1
              }
            ],
          },
          {
            id: 6,
            title: '题目7',
            topicNumber: 7,
            stemContent: [
              datumMap[3],
              datumMap[4],
              datumMap[5],
            ],
            durationTime: 100,
            desc: ['7. 有人说使用手机能够让人变得更聪明、更智慧。你是否同意？请结合资料3-5说明理由。'],
            askList: [
              {
                id: 1,
                type: 1,
              }
            ]
          }
        ]
      }],
      isEnd: false,
      loading: false,
      selectedQidSmall: 1
    }
  },
  methods: {
    getAnswer(obj) {
      this.qidList[1].small[1].stemContent[1].value = obj.text
      this.$forceUpdate()
    },
    async next(sonData, currentQSmall, type) {
      const data = Object.assign({
        exam_id: 1,
        exam_num: '1_' + currentQSmall,
        subject_id: 6,
        subject_name: '手机',
        pic_info: '答案',
        status: 2
      }, sonData)
      if (!this.isEnd) {
        const res = await answerUpload(data)
        this.loading = false
        if (!res || res.code != '200') {
          this.$message({ type: 'error', message: res ? res.msg || res.message : '网络连接失败！' })
          return
        }
      }
      if (type === 'overTime' || this.isEnd) {
        this.nextPage(type === 'overTime')
      } else if (currentQSmall === 6) {
        this.selectedQidSmall = 6
        this.isEnd = true
      } else {
        this.selectedQidSmall = currentQSmall + 1
      }
      this.$forceUpdate()
    },
    nextPage(isEnd) {
      // setTimeout(() => {
      const examArr = JSON.parse(sessionStorage.currentExamGroup).exam
      if (isEnd) {
        this.$message.info('测评结束')
        if (examArr.length === 1) {
          this.$router.push({
            name: 'examLogin',
            query: {
              subject: 'criticismSteer',
              type: 'public',
              isEnd: true
            }
          })
        } else {
          this.$router.push({
            name: 'examLogin',
            query: {
              isEnd: true,
              subject: sessionStorage.subjectName,
              time: JSON.parse(sessionStorage.currentExamGroup).name.includes('下午') ? 'pm' : undefined
            }
          })
        }
      } else {
        sessionStorage.currentExamIndex = Number(sessionStorage.currentExamIndex) + 1
        this.$router.push({
          name: examArr[sessionStorage.currentExamIndex]
        })
      }
    }
  }
}
</script>

<style lang="less">
.content{
  height: 100%;
}
</style>
